import React from 'react';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { AxiosResponse, CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';

const columns = [
  { field: 'item', headerName: 'Item', width: 110 },
  { field: 'coins', headerName: 'Coins', width: 200, flex: 0.4 },
  { field: 'cash', headerName: 'Cash', width: 250, flex: 0.4 },
  { field: 'productId', headerName: 'Product Id', width: 260, flex: 0.6 },
  { field: 'creationDate', headerName: 'Creation Date', ...formatColWithDate, width: 190, flex: 0.5 },
  { field: 'closed', headerName: 'Closed', width: 130 },
  { field: 'closureDate', headerName: 'Closure Date', ...formatColWithDate, width: 190, flex: 0.5 },
];

interface DailyDealInfo {
  item: number;
  coins: number;
  cash: number;
  productId: string;
  creationDate: string;
  closed: boolean;
  closureDate: string;
}

let index = 0;
function createData(info: DailyDealInfo) {
  index += 1;
  return { id: index, ...info };
}

const DailyDeals = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices
      .get<DailyDealInfo[]>(`/admin/daily-deals/${requestPid}`, { cancelToken })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) return { ...error.response, data: [] } as AxiosResponse<DailyDealInfo[]>;
        throw error;
      });
  }

  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });
  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  return (
    <>
      <TabTableContainer>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default DailyDeals;
